export default "\r\n\r\n<app-shell></app-shell>"